module.exports = __webpack_public_path__ + "img/UTGREE-1.6a4dad13.jpg";